// removed by extract-text-webpack-plugin
module.exports = {"root":"Editor__root___2_EcU"};


//////////////////
// WEBPACK FOOTER
// ./src/components/TemplateComponents/Container/Editor/Editor.scss
// module id = 984
// module chunks = 0